import React from "react";
import {
  searchReadyToSendOrders,
  clearSearch,
} from "../../../redux/General/generalActions";
import { DataGrid } from "@material-ui/data-grid";
import { Avatar, Typography, Grid } from "@material-ui/core";
import { connect } from "react-redux";
import OrderDetails from "../orderDetails/OrderDetails";
import { useTablesStyle } from "../../../styles/tableStyle";
import NoRowsMessage from "../../../components/NoRowsMessage";
import CustomLoading from "../../../components/CustomLoading";
import Store from "../../../redux/Store";
import {
  findReadyToSendOrders,
  set_Refresh,
} from "../../../redux/Orders/OrderActionCreators";

const ReacyOrdersTable = ({
  readyToSendOrders,
  searchReducer,
  loading,
  refresh,
}) => {
  const ordersToSend = searchReadyToSendOrders(
    readyToSendOrders.data,
    searchReducer
  ).sort((a, b) => {
    if (a.immediate_delivery || b.immediate_delivery) return true;
    return false;
  });
  const classes = useTablesStyle();
  React.useEffect(() => {
    Store.dispatch(set_Refresh(refresh + 1));
    // eslint-disable-next-line
  }, []);
  React.useEffect(() => {
    return () => {
      clearSearch();
      Store.dispatch(findReadyToSendOrders({ data: [] }));
    };
  }, []);

  const customer_header_list = [
    {
      field: "number",
      headerName: "شماره سفارش",
      flex: 0.4,
      headerAlign: "center",
      align: "center",

      renderCell: (value) => (
        <OrderDetails
          rowValue={value.value}
          orderId={value.row.id}
          position="number"
        />
      ),
    },
    {
      field: "price",
      headerName: "هزینه کل",
      flex: 0.4,
      headerAlign: "center",
      align: "center",

      renderCell: (value) => (
        <Typography variant="body2">{value.value.toLocaleString()}</Typography>
      ),
    },

    {
      field: "qtty",
      headerName: "تعداد فایل",
      headerAlign: "center",
      align: "center",
      flex: 0.3,

      renderCell: (value) => (
        <Avatar variant="circular" className={classes.Avatar}>
          {value.value}
        </Avatar>
      ),
    },

    {
      field: "order_date",
      headerName: "زمان سفارش",
      headerAlign: "center",
      align: "center",
      width: 180,

      renderCell: (value) => {
        return (
          <Grid className={classes.TableCell} style={{ width: 150 }}>
            <Grid container justifyContent="flex-end" item xs={4}>
              <Typography color="textSecondary" variant="subtitle2">
                {value.row.order_weekday}
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography color="textSecondary" variant="subtitle2">
                {value.row.order_date}
              </Typography>
              <Typography color="textSecondary" variant="subtitle2">
                {value.row.order_time}
              </Typography>
            </Grid>
          </Grid>
        );
      },
    },
    {
      field: "delivery_date",
      headerName: "زمان ارسال",
      headerAlign: "center",
      align: "center",
      width: 180,

      renderCell: (value) => {
        return (
          <>
            {!value.row.immediate_delivery ? (
              <Grid className={classes.TableCell}>
                <Grid container justifyContent="center" item xs={4}>
                  <Typography color="textSecondary" variant="subtitle2">
                    {value.row.delivery_weekday}
                  </Typography>
                </Grid>
                <Grid container justifyContent="center" item xs={8}>
                  <Typography color="textSecondary" variant="subtitle2">
                    {value.row.delivery_date}
                  </Typography>
                  <Typography color="textSecondary" variant="subtitle2">
                    {value.row.delivery_start_time + " "}-
                    {" " + value.row.delivery_end_time}
                  </Typography>
                </Grid>
              </Grid>
            ) : (
              <Grid container justifyContent="center" alignItems="center">
                <Typography variant="h5" style={{ color: "#da5c87" }}>
                  فوری
                </Typography>
              </Grid>
            )}
          </>
        );
      },
    },

    {
      field: "id",
      headerName: "مشاهده",
      headerAlign: "center",
      align: "center",
      flex: 0.4,

      renderCell: (value) => {
        return (
          <OrderDetails
            rowValue={value.row.number}
            orderId={value.value}
            position="visibility"
          />
        );
      },
    },
  ];

  return (
    <DataGrid
      columns={customer_header_list}
      rows={ordersToSend}
      loading={loading}
      sortingOrder={["desc", "asc"]}
      disableSelectionOnClick
      disableColumnFilter
      getRowClassName={(params, details) => {
        if (params.row.immediate_delivery || params.row?.lated) {
          return "test";
        }
      }}
      disableColumnMenu
      hideFooter
      pageSize={ordersToSend.length}
      components={{
        NoRowsOverlay: NoRowsMessage,
        LoadingOverlay: CustomLoading,
      }}
    />
  );
};

const mapToStateProps = (props) => {
  const { OrderReducer, searchReducer } = props;
  const { readyToSendOrders, loading, refresh } = OrderReducer;

  return { readyToSendOrders, searchReducer, loading, refresh };
};

export default connect(mapToStateProps)(ReacyOrdersTable);
